import { createContext, useContext } from "react";
import { TableInstance } from "react-table";

export interface ITableContext<D extends object> {
  table?: TableInstance<D>;
}

export const TableContext = createContext<ITableContext<Record<string, any>>>({});

export function useTableContext() {
  return useContext(TableContext);
}
